'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var applicationRecommend = function applicationRecommend() {
  return import('@/page/applicationRecommend');
};
var applicationRecommendList = function applicationRecommendList() {
  return import('@/page/applicationRecommend/applicationRecommend-list');
};
var applicationRecommendDetail = function applicationRecommendDetail() {
  return import('@/page/applicationRecommend/applicationRecommend-detail');
};
exports.default = [{
  path: '/applicationRecommend',
  name: 'applicationRecommend',
  component: applicationRecommend,
  children: [{
    path: 'applicationRecommend-list',
    name: 'applicationRecommend-list',
    component: applicationRecommendList
  }, {
    path: 'applicationRecommend-detail',
    name: 'applicationRecommend-detail',
    component: applicationRecommendDetail
  }]
}];